import { SiteText } from "../Classes";

export const HungarianSiteText = new SiteText(
    'keresés',
    'Keress rá a bajnokodra!',
    'Ki a te bajnokod?',
    'Legújabb hős',
    'Állítsd össze a csapatodat!',
    'Kattints egy ösvényre, majd kattints rá egy bajnokra hogy hozzárendelhesd!',
    'Kezdő életpontok',
    'Kezdő páncél',
    'Képességek költségtípusa',
    'szerep',
    'történet',
    'passzív',
    'képességek',
    'Töltési idő másodpercben szinttől függően',
    'Képesség költsége szinttől függően',
    'Ez a karakter nem található!',
    'Ismeretlen',
    'Állítsd össze a csapatodat!',
    'Nincs elég AP!',
    'Nincs elég AD!',
    'Ki az ADC?',
    'De ki a tank?',
    'Remek csapat-kombináció!',
    'Nem is rossz csapat-kombináció!',
    'Magyar nyelv beállítása...'
);

export const EnglishSiteText = new SiteText(
    'search',
    'Search for your champion!',
    'Who is your champion?',
    'Latest champion',
    'Assemble your team!',
    'Click on a lane and choose a champ to save and assign that to its role!',
    'Starting health points',
    'Starting armor points',
    'Cost type',
    'role',
    'lore',
    'passive',
    'skills',
    'Cooldown on each skill-level',
    'Cost on each skill-level',
    'This character could not be found!',
    'Unknown',
    'Set up your team!',
    'Not enough magical damage!',
    'Not enough attack damage!',
    'Who is the ADC?',
    'But who is the tank?',
    'Your team setup is good!',
    'Your team setup is not bad!',
    'Changing language...'
);